module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/img_data01-sp-534b97bbef8985c64b999a51c8573235.png";